import React from "react";
import PropTypes from "prop-types";
import {
  Button,
  Card,
  CardHeader,
  CardBody,
  Form,
  FormGroup,
  Input,
  Row,
  Col,
  ButtonGroup
} from "reactstrap";
import classNames from "classnames";
import { cnpjMask, phoneMask } from '../../helpers/utils'
import { IMPORTATION_TYPE, ORGANIZATION_TYPE, USER_LEVEL } from "../../configs/constants";
import Autocomplete from '@mui/material/Autocomplete';
import TextField from '@mui/material/TextField';
import { isMobile, autoCompleteSx } from '../../helpers/utils'

function mountEvent(name,value) {
  return {
    target:{
      name: name,
      value: value,
    }
  };
};

const OrganizationComponent = ({
  onChange,
  onChangeImportation,
  onFileChange,
  onCustomFileChange,
  onClick,
  onCancel,
  organization,
  onChangeAddress,
  onKeyUpOrganizationFather,
  onChangeOrganizationFather,
  organizationsFather,
  organizationFather,
  userLevel,
  onKeyUpOrganizationPattern,
  onChangeOrganizationPattern,
  organizationsPattern,
  organizationPattern,
  existResaleName,
  resaleNameError,
}) => {
  return (
    <Row>
      <Col>
        <Card>
          <CardHeader>
            <h5 className="title">Estabelecimento</h5>
          </CardHeader>
          <CardBody>
            <Form
              onSubmit={(e) => {
                e.preventDefault();
                onClick();
              }}
            >
              <Row>
                <Col xs={12} md={4}>
                  <FormGroup>
                    <label>CPF ou CNPJ</label>
                    <Input
                      name="cnpj"
                      type="text"
                      placeholder="CPF ou CNPJ"
                      value={cnpjMask(organization?.cnpj)}
                      onChange={(e) => onChange(e)}
                    />
                  </FormGroup>
                </Col>
                <Col xs={12} md={4}>
                  <FormGroup>
                    <label>Nome</label>
                    <Input
                      name="name"
                      type="text"
                      placeholder="Nome"
                      value={organization?.name}
                      onChange={(e) => onChange(e)}
                    />
                  </FormGroup>
                </Col>
                  <Col xs={12} md={4}>
                    <FormGroup>
                      <label>Tipo</label>
                      <ButtonGroup style={{width: "100%"}}>
                        <Button disabled={userLevel !== USER_LEVEL.manager} style={{width: "50%", padding: isMobile() ? "0px" : "10px 22px"}} color="info" className={classNames("btn-simple", {active: organization?.type === ORGANIZATION_TYPE.customer})} outline onClick={()=>onChange(mountEvent("type", ORGANIZATION_TYPE.customer))}>Cliente</Button>
                        <Button disabled={userLevel !== USER_LEVEL.manager} style={{width: "50%", padding: isMobile() ? "0px" : "10px 22px"}} color="info" className={classNames("btn-simple", {active: organization?.type === ORGANIZATION_TYPE.resale})} outline onClick={()=>onChange(mountEvent("type", ORGANIZATION_TYPE.resale))}>Revenda</Button>
                      </ButtonGroup>
                    </FormGroup>
                  </Col>
              </Row>
              {organization?.type === ORGANIZATION_TYPE.resale && (
                <>
                  <Row>
                    <Col xs={12} md={4}>
                      <FormGroup>
                        <label>Nome customizado</label>

                        {resaleNameError && (
                          <div className="text-danger" style={{ marginBottom: 6 }}>
                            {resaleNameError}
                          </div>
                        )}

                        <Input
                          name="resaleName"
                          type="text"
                          placeholder="Nome"
                          value={organization?.resaleName}
                          onChange={existResaleName}
                        />
                      </FormGroup>
                    </Col>
                    {organization?.appUrl !== undefined && organization?.appUrl !== "" && organization?.appUrl !== null ?
                    <Col xs={12} md={4}>
                      <FormGroup>
                        <label>Url customizada do aplicativo</label>
                        <Input
                          readOnly={true}
                          name="appUrl"
                          type="text"
                          value={organization?.appUrl}
                        />
                      </FormGroup>
                    </Col>
                    : (<></>)}
                    {organization?.appUrl !== undefined && organization?.appUrl !== "" && organization?.appUrl !== null ?
                    <Col xs={12} md={4}>
                      <FormGroup>
                        <label>Url customizada do manager</label>
                        <Input
                          readOnly={true}
                          name="managerUrl"
                          type="text"
                          value={organization?.managerUrl}
                        />
                      </FormGroup>
                    </Col>
                    : (<></>)}
                  </Row>
                  <Row>
                    <Col xs={12} md={6}>                
                      <label>Logo da URL customizada (a extensão suportada é .PNG)</label><br/>
                      <input id="uploadCaptureInputCustomLogo" type="file" onChange={onCustomFileChange} />  
                    </Col>
                    <Col xs={12} md={6}>
                      <img alt="" src={organization?.customLogoUrl} style={{maxWidth: "200px", maxHeight: "200px"}}/>  
                    </Col> 
                  </Row> 
                </>
              )}
              {organization?.type === ORGANIZATION_TYPE.customer && (
              <>             
                <Row>
                  <Col xs={12} md={6}>
                    <FormGroup>
                      <label style={{marginBottom: "0px"}}>Matriz</label>
                      <Autocomplete
                        freeSolo
                        noOptionsText={"Nenhum item"}                          
                        onChange={(event, value) =>                         
                          onChangeOrganizationPattern(value)
                        }
                        style={{paddingBottom: "10px"}}                                      
                        value={organizationPattern?.name}
                        id="organizationFather"
                        options={organizationsPattern.map((organizationPattern) => organizationPattern.name)}
                        isOptionEqualToValue={(option, value) => option.organizationId === value.organizationId}
                        size="small"
                        renderInput={(params) => (
                          <TextField
                            {...params}
                            variant="standard"
                            onInput={(e) => onKeyUpOrganizationPattern(e.target.value)}
                          />
                        )}
                        sx={autoCompleteSx()}
                        renderOption={(props, option) => {
                          return (
                            <span  {...props}>
                              {option}
                            </span>
                          );
                        }}                      
                      />
                    </FormGroup>
                  </Col> 
                  <Col xs={12} md={6}>
                    <FormGroup>
                      <label style={{marginBottom: "0px"}}>Revenda</label>
                      <Autocomplete
                        freeSolo
                        noOptionsText={"Nenhum item"}                          
                        onChange={(event, value) =>                         
                          onChangeOrganizationFather(value)
                        }
                        style={{paddingBottom: "10px"}}                                      
                        value={organizationFather?.name}
                        id="organizationFather"
                        options={organizationsFather.map((organizationFather) => organizationFather.name)}
                        isOptionEqualToValue={(option, value) => option.organizationId === value.organizationId}
                        size="small"
                        renderInput={(params) => (
                          <TextField
                            {...params}
                            variant="standard"
                            onInput={(e) => onKeyUpOrganizationFather(e.target.value)}
                          />
                        )}
                        sx={autoCompleteSx()}
                        renderOption={(props, option) => {
                          return (
                            <span  {...props}>
                              {option}
                            </span>
                          );
                        }}                      
                      />
                    </FormGroup>
                  </Col>                      
                </Row>
               </>
              )}
              <Row>
                <Col xs={12} md={6}>
                  <FormGroup>
                    <label>Telefone</label>
                    <Input
                      name="phone"
                      type="tel"
                      maxLength="15"
                      placeholder="Telefone"
                      value={phoneMask(organization?.phone)}
                      onChange={(e) => onChange(e)}
                    />
                  </FormGroup>
                </Col>
                <Col xs={12} md={6}>
                  <FormGroup>
                    <label>Celular</label>
                    <Input
                      name="mobilePhone"
                      type="tel"
                      maxLength="15"
                      placeholder="Celular"
                      value={phoneMask(organization?.mobilePhone)}
                      onChange={(e) => onChange(e)}
                    />
                  </FormGroup>
                </Col>
              </Row>
              <Row>
                <Col xs={12} md={6}>
                  <FormGroup>
                    <label>E-mails</label>
                    <Input
                      name="billingEmails"
                      type="text"
                      placeholder="E-mails"
                      value={organization?.billingEmails}
                      onChange={(e) => onChange(e)}
                    />
                  </FormGroup>
                </Col>
                <Col xs={12} md={6}>
                  <FormGroup>
                    <label>Responsável</label>
                    <Input
                      name="contactName"
                      type="text"
                      placeholder="Responsável"
                      value={organization?.contactName}
                      onChange={(e) => onChange(e)}
                    />
                  </FormGroup>
                </Col>
              </Row> 
              <Row>                
                <Col xs={12} md={4}>
                  <FormGroup>
                    <label>CEP</label><br/>
                    <Input id="zipcode" name="zipcode" type="text" maxLength={10} value={organization?.address?.zipcode} onChange={(e) => onChangeAddress(e)} />
                  </FormGroup>
                </Col>
                <Col xs={12} md={8}>
                  <FormGroup>
                    <label>Rua</label><br/>
                    <Input id="street" name="street" type="text" value={organization?.address?.street} onChange={(e) => onChangeAddress(e)} />
                  </FormGroup>
                </Col>                
              </Row>
              <Row>
                <Col xs={12} md={4}>
                  <FormGroup>                
                    <label>Bairro</label><br/>
                    <Input id="neighborhood" name="neighborhood" type="text" value={organization?.address?.neighborhood} onChange={(e) => onChangeAddress(e)} />  
                  </FormGroup>
                </Col>
                <Col xs={12} md={4}>
                  <FormGroup>
                    <label>Cidade</label><br/>
                    <Input id="city" name="city" type="text" value={organization?.address?.city} onChange={(e) => onChangeAddress(e)} />
                  </FormGroup> 
                </Col>
                <Col xs={12} md={4}>
                  <FormGroup>                
                    <label>Estado</label><br/>
                    <Input id="state" name="state" type="text" value={organization?.address?.state} onChange={(e) => onChangeAddress(e)} />  
                  </FormGroup>
                </Col>                
              </Row>
              <Row>
                <Col xs={12} md={6}>
                  <FormGroup>               
                    <label>Número</label><br/>
                    <Input id="number" name="number" type="text" value={organization?.address?.number} onChange={(e) => onChangeAddress(e)} />
                  </FormGroup>  
                </Col>
                <Col xs={12} md={6}>
                  <FormGroup>               
                    <label>Complemento</label><br/>
                    <Input id="complement" name="complement" type="text" value={organization?.address?.complement} onChange={(e) => onChangeAddress(e)} />
                  </FormGroup>  
                </Col>                
              </Row>
              <Row>
                <Col xs={12} md={6}>                
                  <label>A extensão suportada é .PNG</label><br/>
                  <input id="uploadCaptureInputLogo" type="file" onChange={onFileChange} />  
                </Col>
                <Col xs={12} md={6}>
                  <img alt="" src={organization?.logoUrl} style={{maxWidth: "200px", maxHeight: "200px"}}/>  
                </Col> 
              </Row>
              <Row>
                <Col>
                  <FormGroup>
                    <label>Tipo de integração</label><br/>
                    <ButtonGroup>
                      <Button color="info" className={classNames("btn-simple", {active: organization?.importation?.type === IMPORTATION_TYPE.file})} outline onClick={()=>onChangeImportation(mountEvent("type", IMPORTATION_TYPE.file))}>Arquivo</Button>
                      <Button color="info" className={classNames("btn-simple", {active: organization?.importation?.type === IMPORTATION_TYPE.agent})} outline onClick={()=>onChangeImportation(mountEvent("type", IMPORTATION_TYPE.agent))}>Agente</Button>
                      <Button color="info" className={classNames("btn-simple", {active: organization?.importation?.type === IMPORTATION_TYPE.rpinfo})} outline onClick={()=>onChangeImportation(mountEvent("type", IMPORTATION_TYPE.rpinfo))}>RPInfo</Button>
                      <Button color="info" className={classNames("btn-simple", {active: organization?.importation?.type === IMPORTATION_TYPE.primesatus})} outline onClick={()=>onChangeImportation(mountEvent("type", IMPORTATION_TYPE.primesatus))}>Prime/Satus</Button>
                    </ButtonGroup>                        
                  </FormGroup>
                </Col>
              </Row>
              <Row>
                <Col xs={12} md={12}>
                  <FormGroup>
                    <label>Separador do arquivo (Use este campo somente se quiser forçar um separador específico. Se estiver em branco, o sistema tentará identificar automaticamente.)</label>
                    <Input
                      name="fileSeparator"
                      type="text"
                      placeholder="Exemplo: |"
                      value={organization?.fileSeparator}
                      onChange={(e) => onChange(e)}
                    />
                  </FormGroup>
                </Col>
              </Row>           
              {organization?.importation?.type >= IMPORTATION_TYPE.rpinfo && (         
              <Row>
                <Col xs={12} md={6}>
                  <FormGroup>
                    <label>Link da API</label>
                    <Input
                      name="baseUrl"
                      type="text"
                      placeholder="https://exemplo.com"
                      value={organization?.importation?.baseUrl}
                      onChange={(e) => onChangeImportation(e)}
                    />
                  </FormGroup>
                </Col>               
                <Col xs={12} md={6}>
                  <FormGroup>
                    <label>Usuário</label>
                    <Input
                      name="username"
                      type="text"
                      placeholder="Nome de usuário"
                      value={organization?.importation?.username}
                      onChange={(e) => onChangeImportation(e)}
                    />
                  </FormGroup>
                </Col>
                <Col xs={12} md={6}>
                  <FormGroup>
                    <label>Senha ou Token</label>
                    <Input
                      name="password"
                      type="text"
                      placeholder="Senha do usuário da API"
                      value={organization?.importation?.password}
                      onChange={(e) => onChangeImportation(e)}
                    />
                  </FormGroup>
                </Col>
                <Col xs={12} md={6}>
                  <FormGroup>
                    <label>Nº ou CNPJ da Loja (Preencha apenas se for um número de loja ou um CNPJ diferente do cadastrado.)</label>
                    <Input
                      name="branchId"
                      type="text"
                      placeholder="Identificador da loja"
                      value={organization?.importation?.branchId}
                      onChange={(e) => onChangeImportation(e)}
                    />
                  </FormGroup>
                </Col>
              </Row>
               )}
              <Row>
                <Col style={{textAlign: "right"}}>
                  <Button
                    className="btn-fill btn-xs"
                    color="danger"
                    type="button"
                    onClick={()=>onCancel()}
                  >
                    Voltar
                  </Button>
                  <Button
                    className="btn-fill btn-xs"
                    color="primary"
                    type="submit"
                  >
                    Salvar
                  </Button>
                </Col>
              </Row>                  
            </Form>
          </CardBody>
        </Card>
      </Col>
    </Row>
  );
};

OrganizationComponent.propTypes = {
  onChange: PropTypes.func.isRequired,
  onClick: PropTypes.func.isRequired,
  onCancel: PropTypes.func.isRequired,
  organization: PropTypes.object.isRequired
};

export default OrganizationComponent;